<router-outlet></router-outlet>
<p-toast position="bottom-right">
  <ng-template let-message pTemplate="message">
    <div style="display: flex; flex-direction: column; width: 100%; gap: 4px;">
      <div style="display: flex; align-items: center; gap: 8px;">
        <i [class]="message.severity === 'success' ? 'pi pi-check-circle' : message.severity === 'error' ? 'pi pi-times-circle' : message.severity === 'warn' ? 'pi pi-exclamation-triangle' : 'pi pi-info-circle'"
           [style.color]="message.severity === 'success' ? '#22c55e' : message.severity === 'error' ? '#ef4444' : message.severity === 'warn' ? '#f59e0b' : '#3b82f6'"
           style="font-size: 1.25rem"></i>
        <span style="font-weight: 600;">{{ message.summary }}</span>
      </div>
      <div style="margin-left: 28px; color: #4b5563;">{{ message.detail }}</div>
      @if (message.data?.link) {
        <a [href]="message.data.link"
           target="_blank"
           style="margin-left: 28px; margin-top: 4px; color: #3b82f6; font-weight: 500; text-decoration: none; display: inline-flex; align-items: center; gap: 4px;">
          {{ message.data.linkText || 'View Progress' }}
          <i class="pi pi-external-link" style="font-size: 0.7rem"></i>
        </a>
      }
    </div>
  </ng-template>
</p-toast>